import styled from 'styled-components'
import { LoginFormProps } from '.'

export const LoginFormContainer = styled.div<LoginFormProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 356px;

  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 16px;

    h2 {
      margin: 0 0 16px 0;
      font-weight: 400;
      font-size: 16px;
      color: var(--gray-800);
      align-self: flex-start;
    }

    button.submit-button {
      align-self: ${({ sessionExpired }) => (sessionExpired ? 'flex-start' : 'auto')};
      margin-top: 24px;
    }

    > div:first-of-type {
      margin-bottom: 16px;
    }

    a.link {
      align-self: flex-start;
      color: var(--blue-500);

      font-weight: 500;
      font-size: 12px;
    }
  }

  .check-box label {
    color: var(--gray-600);
    font-size: 12px;
  }
`
